import * as React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ANIMATIONS } from '../../utils';

import { SectionBeautifulViz } from './SectionBeautifulViz';
import { SectionMagic } from './SectionMagic';
import { SectionNoCode } from './SectionNoCode';
import { SectionSQLPython } from './SectionSQLPython';

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  max-width: ${({ theme }) => theme.maxWidth.PAGE};
  width: 100%;
  padding: 100px 40px 150px;
  position: relative;
  gap: 150px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding: 80px 40px 100px;
    gap: 120px;
  }
`;

export const NewWayToNotebookTout: React.ComponentType = React.memo(() => {
  return (
    <Wrapper {...ANIMATIONS.SimpleFadeIn}>
      <SectionSQLPython />
      <SectionNoCode />
      <SectionMagic />
      <SectionBeautifulViz />
    </Wrapper>
  );
});
